
'use client';

import React from "react";
import { AlertCircle } from "lucide-react";
import { P } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";

interface SearchErrorProps {
  query?: string;
  onRetry?: () => void;
  error?: string;
}

const SearchError: React.FC<SearchErrorProps> = ({ query = "", onRetry, error }) => {
  return (
    <div className="absolute z-50 top-full mt-1 w-full bg-mono-charcoal border border-mono-slateGray/30 rounded-md p-4 animate-in fade-in slide-in-from-top-2 duration-200">
      <div className="flex flex-col items-center text-center gap-2">
        <AlertCircle className="h-8 w-8 text-destructive mb-2" />
        <P size="h4" className="font-medium">Search Error</P>
        <P variant="muted" className="text-sm">
          {query ? `We couldn't search for "${query}".` : "Search error occurred."}
          {error && <span className="block mt-1 text-xs opacity-80">{error}</span>}
        </P>
        {onRetry && (
          <Button 
            onClick={onRetry} 
            variant="secondary" 
            size="sm" 
            className="mt-2"
          >
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
};

export default SearchError;
